import { useContext } from 'react';

import { ToasterContext } from './Toaster';
import type { ToasterContextType } from './types';

export const useToast = (): ToasterContextType => {
  const context = useContext(ToasterContext);

  if (!context) {
    throw new Error('useToast must be used within a Toaster provider');
  }

  return context;
};
